<template>
  <div class="scene-setting">
    <my-header title="系统场景设置" back-path="/user"></my-header>
    <div class="container">
      <div class="content">
        <div class="item" v-for="(item,i) in itemList" :key="`scene_${i}`">
          <div class="title">
            <span v-text="item.name"></span>
          </div>
          <div>
            <img :src="stateIcon(item.visible)" @click="changeSave(item)"/>
          </div>
        </div>
      </div>
      <div class="remark">
        <img src="@/assets/images/home/zy.png"/>
        <span>系统预设场景不允许删除，可以隐藏或显示。</span>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/HeaderTitle'
import { mapState } from 'vuex'
import basic from '@/model/zone'
import scene from '@/model/scene'
import { Message } from 'element-ui'

export default {
  name: 'SceneSetting',
  components: {
    MyHeader
  },
  data () {
    return {
      itemList: []
    }
  },
  computed: {
    ...mapState(['zone'])
  },
  async created () {
    if (!this.zone) {
      await basic.getBasicInfo()
      this.initScenes()
    } else {
      this.initScenes()
    }
  },
  methods: {
    async changeSave (item) {
      // 收集结果，并提交
      item.visible = !item.visible
      try {
        await scene.setVisible(this.zone.id, item.id, item.visible ? 1 : 0)
        // 重载场景数据
        scene.load(this.zone.id)
      } catch (e) {
        Message.error(e.message)
      }
    },
    stateIcon (state) {
      if (state) {
        return require('../../assets/images/home/xs.png')
      } else {
        return require('../../assets/images/home/yc.png')
      }
    },
    async initScenes () {
      const result = await scene.getSystemScene(this.zone.id)
      this.itemList = result.data
    }
  }
}
</script>

<style scoped lang="less">

.scene-setting {
  height: 100%;
  display: flex;
  flex-direction: column;
  .container {
    flex: 1;
    position: relative;
    padding: 65px 20px 20px 20px;
    overflow-y: auto;
    & .content {
      border-radius: 4px;
      background-color: white;
      padding: 0px 20px;
      & .item:first-child {
        border: 0px;
      }
      & .item {
        padding: 10px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid rgba(220, 220, 220, .5);
        & .title {
          font-size: 17px;
          font-weight: 600;
          color: rgba(34, 34, 34, 1);
        }
        & img {
          width: 30px;
          cursor: pointer;
        }
      }
    }
    & .remark {
      font-size: 15px;
      font-weight: 400;
      color: rgba(198, 198, 198, 1);
      margin-top: 12px;
      display: flex;
      align-items: flex-start;
      & img {
        width: 18px;
        margin-right: 8px;
        vertical-align: middle;
      }
    }
  }
}
</style>
